import { useDesktopStore } from '../../stores/desktopStore'
import { useWindowStore } from '../../stores/windowStore'
import { DesktopIcon } from './DesktopIcon'
import './Desktop.css'

export function Desktop() {
  const icons = useDesktopStore((state) => state.icons)
  const clearSelection = useDesktopStore((state) => state.clearSelection)
  const setStartMenuOpen = useDesktopStore((state) => state.setStartMenuOpen)

  const handleClick = (e: React.MouseEvent) => {
    // Only handle clicks directly on the desktop, not on icons
    if (e.target === e.currentTarget) {
      clearSelection()
      setStartMenuOpen(false)
    }
  }

  return (
    <div className="desktop-area" onClick={handleClick}>
      {icons.map((icon) => (
        <DesktopIcon key={icon.id} icon={icon} />
      ))}

      {/* ASCII Art Logo */}
      <div className="desktop-logo" aria-hidden="true">
        <pre>{`
  ██████╗ ███████╗██████╗ ███████╗ ██████╗ ███╗   ██╗ █████╗
  ██╔══██╗██╔════╝██╔══██╗██╔════╝██╔═══██╗████╗  ██║██╔══██╗
  ██████╔╝█████╗  ██████╔╝███████╗██║   ██║██╔██╗ ██║███████║
  ██╔═══╝ ██╔══╝  ██╔══██╗╚════██║██║   ██║██║╚██╗██║██╔══██║
  ██║     ███████╗██║  ██║███████║╚██████╔╝██║ ╚████║██║  ██║
  ╚═╝     ╚══════╝╚═╝  ╚═╝╚══════╝ ╚═════╝ ╚═╝  ╚═══╝╚═╝  ╚═╝
       S C I E N C E  |  Identity Intelligence
        `}</pre>
      </div>
    </div>
  )
}
